const SectionEditorComponent = {
    templateUrl: '/formViewer/editor/section/sectionEditor.tpl.html',
    controller: 'sectionEditorController',
    bindings: {
        sectionStructure: '<',
        rootFormId: '<'
    }
};

angular.module('umFormViewer')
    .component('uiSectionEditor', SectionEditorComponent);
